import { render } from "./equipamentosView.vue?vue&type=template&id=36ace2cc&scoped=true"
import script from "./equipamentosView.vue?vue&type=script&lang=js"
export * from "./equipamentosView.vue?vue&type=script&lang=js"

import "./equipamentosView.vue?vue&type=style&index=0&id=36ace2cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ace2cc"]])

export default __exports__